import { get, post, patch, destroy } from "@/lib/fetcher";

const API_PATH = "/admin/term_groups";

export const getTermGroups = async () => {
  return await get(API_PATH);
};

export const getTermGroup = async (id) => {
  return await get(`${API_PATH}/${id}`);
};

export const createTermGroup = async (data) => {
  return await post(API_PATH, data);
};

export const updateTermGroup = async (id, data) => {
  return await patch(API_PATH, id, data);
};

export const deleteTermGroup = async (id) => {
  return await destroy(`${API_PATH}/${id}`);
};